import type { AppUser } from "State/Auth/Models/AuthStateModels";

export type Page =
  | ""
  | "403"
  | "404"
  | "user-account"
  | "affiliate"
  | "aml-user-detail"
  | "aml-users"
  | "apple-redirect"
  | "awaiting-email-verification"
  | "awaiting-hunter-email-verification"
  | "beta"
  | "bank-account-detail"
  | "bank-address-list"
  | "banking-auth"
  | "bank-connection-ranking"
  | "bank-connection-ranking-detail"
  | "complete-customer-onboarding"
  | "complete-sso-registration"
  | "contact"
  | "create-employee"
  | "customer-payment-pay"
  | "send-payment"
  | "customer-payments-callback"
  | "dashboard-sell"
  | "dashboard-withdraw"
  | "add-role"
  | "add-role-onboarding"
  | "dashboard"
  | "email-verification"
  | "employee-detail"
  | "employee-initiate-keypad-payment"
  | "employees"
  | "faq-quick-exchange"
  | "forgottenPassword"
  | "google-callback"
  | "google-redirect"
  | "homepage"
  | "initiate-form-payment"
  | "initiate-keypad-payment"
  | "initiate-payment-detail"
  | "initiate-qr-payment"
  | "invoice-create"
  | "language-settings"
  | "latest-pay-point-transaction"
  | "legal-documents"
  | "license-payment-pending"
  | "licenses"
  | "merchant"
  | "merchants"
  | "merchant-detail"
  | "shared-merchant-detail"
  | "merchant-payment"
  | "merchant-new-registration"
  | "merchant-open-registrations"
  | "merchant-complete-registration"
  | "merchant-fee-calculator"
  | "merchant-settlements"
  | "notification-settings"
  | "notifications"
  | "invitations"
  | "migration-required"
  | "onboarding"
  | "orderLicense"
  | "paypoints"
  | "paypoint-detail"
  | "people"
  | "followers"
  | "blocked-users"
  | "new-paypoint"
  | "quick-exchange"
  | "rate-confirmation"
  | "public-profile"
  | "redeem-public"
  | "redeem"
  | "registration-verification"
  | "setPassword"
  | "settings"
  | "sign-in"
  | "sign-up-hunter"
  | "sign-up-merchant"
  | "sign-up"
  | "system-control"
  | "system"
  | "thanks-to-you-withdrawal"
  | "settlements"
  | "transaction-detail"
  | "transactions"
  | "user-detail"
  | "user-list"
  | "welcome"
  | "nfc-exchange"
  | "nfc-assign"
  | "fixed-collector-paypoint"
  | "variable-collector-paypoint"
  | "campaign"
  | "campaign-helppes"
  | "campaign-sanitka"
  | "campaign-kolibrici"
  | "campaign-ochrana-zvirat"
  | "campaign-mcdonald"
  | "campaign-kroky-k-pochopeni"
  | "valor"
  | "notifications-management"
  | "new-notification"
  | "edit-notification"
  | "to-be-verified"
  | "roles-permissions"
  | "stardust"
  | "all-challenges"
  | "where-to-pay"
  | "store-detail"
  | "all-merchants"
  | "hunters"
  | "hunter-detail"
  | "admin-campaigns"
  | "admin-campaigns-create"
  | "admin-campaigns-edit"
  | "transfer-between-accounts"
  | "chat"
  | "admin-coupons"
  | "admin-sso-clients"
  | "sso-authorize"
  | "connected-apps"
  | "admin-stories"
  | "admin-stories-create"
  | "admin-stories-edit"
  | "admin-stories-post"
  | "admin-terminals"
  | "admin-raffle"
  | "raffle"
  | "batch-payments"
  | "batch-payment-detail"
  | "unassigned-merchants";

export const getAppUrl = (asRoutes = false) => {
  return (page: Page) => {
    switch (page) {
      case "403":
        return "/403";
      case "404":
        return "/404";
      case "user-account":
        return "/user-account";
      case "affiliate":
        return "/user-account/affiliate";
      case "aml-users":
        return "/aml-users";
      case "aml-user-detail":
        return `/aml-users${asRoutes ? "/:id" : ""}`;
      case "apple-redirect":
        return "/auth/apple";
      case "awaiting-email-verification":
        return "/awaiting-email-verification";
      case "awaiting-hunter-email-verification":
        return "/awaiting-hunter-email-verification";
      case "beta":
        return "/beta";
      case "bank-account-detail":
        return `/bank-account${asRoutes ? "/:publicID" : ""}`;
      case "bank-address-list":
        return "/bank-address";
      case "banking-auth":
        return "/banking-auth";
      case "batch-payments":
        return "/batch-payments";
      case "batch-payment-detail":
        return `/batch-payments${asRoutes ? "/:id" : ""}`;
      case "bank-connection-ranking":
        return "/bank-connection-ranking";
      case "bank-connection-ranking-detail":
        return `/bank-connection-ranking${asRoutes ? "/:bank" : ""}`;
      case "orderLicense":
        return "/licenses/order";
      case "contact":
        return "/contact";
      case "complete-sso-registration":
        return "/complete-sso-registration";
      case "create-employee":
        return "/employees/create";
      case "complete-customer-onboarding":
        return "/complete-customer-onboarding";
      case "customer-payment-pay":
        return `/pay${asRoutes ? "/:id?" : ""}`;
      case "send-payment":
        return "/send-payment";
      case "dashboard-sell":
        return "/dashboard/sell";
      case "dashboard-withdraw":
        return "/dashboard/withdraw";
      case "dashboard":
        return "/dashboard";
      case "email-verification":
        return `/email-verification${asRoutes ? "/:token" : ""}`;
      case "thanks-to-you-withdrawal":
        return `/thanks-to-you-withdrawal${asRoutes ? "/:token" : ""}`;
      case "employees":
        return "/employees";
      case "employee-detail":
        return `/employees${asRoutes ? "/:publicID" : ""}`;
      case "faq-quick-exchange":
        return "/faq/quick-exchange";
      case "forgottenPassword":
        return "/forgotten-password";
      case "google-callback":
        return "/auth/google/callback";
      case "google-redirect":
        return "/auth/google";
      case "homepage":
        return "/"; // different user roles will resolve this to different pages
      case "initiate-form-payment":
        return "/merchant/payment/initiate/form";
      case "initiate-keypad-payment":
        return "/merchant/payment/initiate/keypad";
      case "employee-initiate-keypad-payment":
        return "/employee/payment/initiate/keypad";
      case "initiate-payment-detail":
        return `/merchant/payment${asRoutes ? "/:id" : ""}`;
      case "initiate-qr-payment":
        return `/qr-payment/initiate${asRoutes ? "/:id" : ""}`;
      case "invoice-create":
        return "/invoice/create";
      case "language-settings":
        return "/language-settings";
      case "latest-pay-point-transaction":
        return `/ppt${asRoutes ? "/:id" : ""}`; //ppt as PayPointTransaction
      case "legal-documents":
        return "/legal-documents";
      case "license-payment-pending":
        return "/license-payment-pending";
      case "licenses":
        return "/licenses";
      case "merchant":
        return "/merchant/overview";
      case "merchants":
        return "/merchants";
      case "merchant-detail":
        return `/merchants${asRoutes ? "/:publicID" : ""}`;
      case "shared-merchant-detail":
        return `/shared-merchant-detail${asRoutes ? "/:publicID" : ""}`;
      case "merchant-payment":
        return "/merchant-payment";
      case "merchant-new-registration":
        return "/merchants/registration/new";
      case "merchant-open-registrations":
        return "/merchants/registrations";
      case "merchant-complete-registration":
        return `/merchants/registration/complete${
          asRoutes ? "/:publicID" : ""
        }`;
      case "merchant-fee-calculator":
        return "/merchant/fee-calculator";
      case "merchant-settlements":
        return "/merchant/settlements";
      case "notification-settings":
        return "/notification-settings";
      case "notifications":
        return "/notifications";
      case "add-role":
        return "/add-role";
      case "add-role-onboarding":
        return "/add-role/onboarding";
      case "invitations":
        return "/invitations";
      case "migration-required":
        return "/migration-required";
      case "onboarding":
        return "/onboarding";
      case "paypoints":
        return "/paypoints";
      case "paypoint-detail":
        return `/paypoints${asRoutes ? "/:publicID" : ""}`;
      case "new-paypoint":
        return "/paypoints/new";
      case "people":
        return "/people";
      case "followers":
        return "/followers";
      case "blocked-users":
        return "/people/blocked";
      case "quick-exchange":
        return "/quick-exchange";
      case "rate-confirmation":
        return `/rate-confirmation${asRoutes ? "/:externalID" : ""}`;
      // Public profile URL: /profile/{key} where key is a handle or a persona PublicID
      // (unambiguous — the handle charset has no dashes). Links append the key to the
      // navigation form: `${appUrl("public-profile")}/${handle ?? publicID}`.
      case "public-profile":
        return asRoutes ? "/profile/:profileKey" : "/profile";
      case "redeem-public":
        return "/mam-kartu";
      case "redeem":
        return "/karta";
      case "registration-verification":
        return `/registration-verification${asRoutes ? "/:token" : ""}`;
      case "setPassword":
        return `/set-password${asRoutes ? "/:token" : ""}`;
      case "settings":
        return "/settings";
      case "sign-in":
        return "/sign-in";
      case "sign-up-hunter":
        return "/sign-up-hunter";
      case "sign-up-merchant":
        return "/sign-up-merchant";
      case "sign-up":
        return "/sign-up";
      case "system-control":
        return "/system-control";
      case "system":
        return "/system";
      case "settlements":
        return "/settlements";
      case "transaction-detail":
        return `/transaction-detail${asRoutes ? "/:id" : ""}`;
      case "transactions":
        return "/transactions";
      case "user-detail":
        return `/users${asRoutes ? "/:id" : ""}`;
      case "user-list":
        return "/users";
      case "welcome":
        return "/welcome";
      case "nfc-exchange":
        return `/nfc${asRoutes ? "/:id" : ""}`;
      case "nfc-assign":
        return `/nfc${asRoutes ? "/:id/assign" : ""}`;
      case "fixed-collector-paypoint":
        return `/collector-fixed${asRoutes ? "/:id" : ""}`;
      case "variable-collector-paypoint":
        return `/collector-variable${asRoutes ? "/:id" : ""}`;
      case "campaign":
        return `/campaign${asRoutes ? "/:code" : ""}`;
      case "campaign-helppes":
        return "/campaign/helppes";
      case "campaign-sanitka":
        return "/campaign/sanitka";
      case "campaign-kolibrici":
        return "/campaign/kolibrici";
      case "campaign-ochrana-zvirat":
        return "/campaign/ochrana-zvirat";
      case "campaign-mcdonald":
        return "/campaign/mcdonald";
      case "campaign-kroky-k-pochopeni":
        return "/campaign/kroky-k-pochopeni";
      case "valor":
        return "/valor";
      case "notifications-management":
        return "/notifications-management";
      case "new-notification":
        return "/new-notification";
      case "edit-notification":
        return `/edit-notification${asRoutes ? "/:id" : ""}`;
      case "to-be-verified":
        return "/to-be-verified";
      case "roles-permissions":
        return "/admin/roles-permissions";
      case "stardust":
        return "/stardust";
      case "all-challenges":
        return "/all-challenges";
      case "where-to-pay":
        return "/where-to-pay";
      case "store-detail":
        return `/store-detail${asRoutes ? "/:id" : ""}`;
      case "all-merchants":
        return "/all-merchants";
      case "hunters":
        return "/hunters";
      case "hunter-detail":
        return `/hunters${asRoutes ? "/:id" : ""}`;
      case "admin-campaigns":
        return "/admin/campaigns";
      case "admin-campaigns-create":
        return "/admin/campaigns/create";
      case "admin-campaigns-edit":
        return `/admin/campaigns${asRoutes ? "/:id/edit" : ""}`;
      case "admin-coupons":
        return "/admin/coupons";
      case "admin-sso-clients":
        return "/admin/sso-clients";
      case "sso-authorize":
        return "/sso/authorize";
      case "connected-apps":
        return "/settings/connected-apps";
      case "admin-stories":
        return "/admin/stories";
      case "admin-stories-create":
        return "/admin/stories/create";
      case "admin-stories-edit":
        return `/admin/stories${asRoutes ? "/:publicID/edit" : ""}`;
      // Retired one-shot post page — kept so stale links land on the create form.
      case "admin-stories-post":
        return "/admin/stories/post";
      case "admin-terminals":
        return "/admin/terminals";
      case "admin-raffle":
        return "/admin/raffle";
      case "raffle":
        return "/raffle";
      case "unassigned-merchants":
        return "/admin/unassigned-merchants";
      case "transfer-between-accounts":
        return "/transfer";
      case "chat":
        return `/chat${asRoutes ? "/:channelId?" : ""}`;
      default:
        return "";
    }
  };
};

export const appUrl = getAppUrl();

export function resolveStartPage(
  user: AppUser | null,
  unauthenticatedUrl: string | null,
) {
  const appUrl = getAppUrl();

  if (user === null) {
    return appUrl("sign-in");
  }

  if (unauthenticatedUrl) {
    return unauthenticatedUrl;
  }

  return "";
}
